app.factory('payment', ['$http','Config','$rootScope','CacheFactory', function($http,Config,$rootScope,CacheFactory) {

	var factoryFns =  {
	  incrementOrder: function(webQuoteID){
	  	return $http({
		  method: 'POST',
		  url: Config.api_url+'order/increment?brand='+Config.brand_key+'&web-quote-id='+webQuoteID,
		  headers:{
		  	'authorization':Config.api_key
		  }
		});
	  },processPayment: function(data) {
	  	return $http({
		  method: 'POST',
		  data:data,
		  url: Config.base_url+'checkout/process_payment',
		  headers:{
		  	'authorization':Config.api_key
		  }
		});
	  },saveOrder: function(data) {
	  	return $http({
		  method: 'POST',
		  data:data,
		  url: Config.api_url+'order/save',
		  headers:{
		  	'authorization':Config.api_key
		  }
		});
	  },convertDorisToHerbertAddress: function(address,quote){
		  	return {
		  		'postcode': address.postCode,
				'company': address.companyName,
				'address_1': address.address1,
				'address_2': address.address2,
				'town': address.town,
				'county': address.county,
				'country': address.country,
				'firstname': address.contactName,
				'email': quote.email,
				'telephone': address.telephone,
				'floor_level': address.floor,
				'lift_access': address.lift,
				'lift_big_enough': address.liftFit,
				'additional_info': address.additionalInfo,
				'parking_restrictions': address.parkingRestrictions,
				'del_col_contact_name': address.contactName,
				'del_col_contact_number': address.telephone
		  	}
		},processExtensionPayment: function(data) {
		  	return $http({
			  method: 'POST',
			  data:data,
			  url: Config.base_url+'checkout/process_extension_payment',
			  headers:{
			  	'authorization':Config.api_key
			  }
			});
	  	},updateExtQuote: function(data){
			return $http({
			  method: 'POST',
			  data:data,
			  url: Config.api_url+'doris/extension',
			  headers:{
			  	'authorization':Config.api_key
			  }
			});
	  	}
	}
	return factoryFns;

}]);